import MonoBehavior from "../lib/MonoBehavior";
import Vector2 from "../math/Vector2";
import { Random } from "../util/Random";

export default class Asteroid extends MonoBehavior {

    numPoints = Random.int(5, 12, true);
    pointVectors: Vector2[] = [];

    Init(): void {
        let rt = Random.float(0, 2 * Math.PI);
        const type = Math.random() > 0.5 ? 'big' : 'small';
        for (let i = 0; i < this.numPoints; i++) {
            this.pointVectors.push(Vector2.fromRadians(rt).scale(Random.int(type === 'big' ? 50 : 8, type === 'big' ? 100 : 16)));

            rt += (2*Math.PI)/this.numPoints;
        }
    }

    Draw(): void {
        this.ctx.strokeStyle = '#55ff55';
        this.ctx.lineWidth = 1;
        this.engine.strokeShape(...this.pointVectors.map(v => this.transform.position.add(v)));
    }

}